import { render, staticRenderFns } from "./BookCardPopUp.vue?vue&type=template&id=1cbec50c&scoped=true&"
import script from "./BookCardPopUp.vue?vue&type=script&lang=js&"
export * from "./BookCardPopUp.vue?vue&type=script&lang=js&"
import style0 from "./BookCardPopUp.vue?vue&type=style&index=0&id=1cbec50c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbec50c",
  null
  
)

export default component.exports